
  var _styles = {
  "price-logo": {
    "display": "flex",
    "justifyContent": "center",
    "flexDirection": "column",
    "borderRadius": "0.06667rem",
    "backgroundColor": "rgb(255,255,255)",
    "position": "relative",
    "width": "100%",
    "height": "100%"
  },
  "price-logo_price-info": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.50667rem",
    "marginTop": "0.21333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "width": "100%"
  },
  "price-logo_price-info_font-grey": {
    "fontSize": "0.32rem",
    "marginTop": 0,
    "height": "0.66667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular"
  },
  "price-logo_price-img": {
    "width": "100%",
    "height": "2.53333rem",
    "borderTopLeftRadius": "0.06667rem",
    "borderTopRightRadius": "0.06667rem"
  },
  "price-logo_label-img": {
    "position": "absolute",
    "top": "0.13333rem",
    "left": "0.13333rem",
    "height": "0.42667rem"
  },
  "price-logo_recommend2-label-word": {
    "fontSize": "0.29333rem",
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "borderTopLeftRadius": "0.06667rem",
    "borderBottomRightRadius": "0.06667rem"
  },
  "price-logo_left-content": {
    "flex": 1,
    "fontSize": "0.37333rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "height": "fit-content",
    "marginLeft": "0.2rem"
  },
  "price-logo_right-content": {
    "flex": 1,
    "marginRight": "0.2rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "display": "flex",
    "justifyContent": "flex-end",
    "alignItems": "baseline"
  },
  "price-logo_font-grey": {
    "color": "rgb(153,153,153)"
  },
  "price-logo_price": {
    "fontSize": "0.29333rem",
    "color": "rgb(254,117,104)",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular"
  },
  "price-logo_num": {
    "fontSize": "0.37333rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular"
  }
};



  module.exports = _styles;
  